// error may be a string ({error: "..."} bodies) or a raw Error (e.g. a JSON
// parse failure) - normalize so callers can render it directly.
export const getErrorMessage = (
  error,
  fallback = "An unexpected error occurred."
) => (typeof error === "string" ? error : error?.message || fallback);

export const handleJsonResponse = (
  response,
  successCallback,
  errorCallback
) => {
  if (response.ok) {
    response
      .json()
      .then((data) => successCallback(data))
      .catch((error) => errorCallback(error));
  } else {
    response
      .json()
      .then((data) => errorCallback(data.error))
      .catch((error) => errorCallback(error));
  }
};

export const handleBlobResponse = (
  response,
  successCallback,
  errorCallback
) => {
  if (response.ok) {
    response
      .blob()
      .then((data) => successCallback(data))
      .catch((error) => errorCallback(error));
  } else {
    errorCallback(response.statusText);
  }
};
